class SCSHome01 {
  static TEST_NAME = 'SCS_HOME_01';
  static WRAPPER_SELECTOR = '.vehicle-menu-wrapper';
  static TYPEAHEAD_API = 'https://scsbiz3.wearevisum.com/api/v1/vehicles/typeahead';
  static MIN_QUERY_LENGTH = 2;
  static DEBOUNCE_MS = 300;
  static REDIRECT_BASE = 'https://seatcoversolutions.com/products/luxury-seat-covers';
  static CRITICAL_STYLE_ID = 'SCS_HOME_01_critical';

  static installCriticalHide() {
    const root = document.documentElement;
    if (root.classList.contains('SCS_HOME_01-pending')) return;

    root.classList.add('SCS_HOME_01-pending');

    if (document.getElementById(SCSHome01.CRITICAL_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SCSHome01.CRITICAL_STYLE_ID;
    style.textContent = `
      html.SCS_HOME_01-pending,
      html.SCS_HOME_01-ready {
        --scs-home-01-menu-min-h: 98px;
        --scs-home-01-menu-max-w: 720px;
        --scs-home-01-heading-min-h: 0px;
      }
      html.SCS_HOME_01-pending .vehicle-menu-wrapper .vehicle-input,
      html.SCS_HOME_01-pending .vehicle-menu-wrapper .vehicle-input-mobile,
      html.SCS_HOME_01-pending .vehicle-menu-wrapper > .line,
      html.SCS_HOME_01-pending .custom__hero.hero .select-your-vehicle,
      html.SCS_HOME_01-ready .custom__hero.hero .select-your-vehicle{
          background: #000 !important;
      }
      html.SCS_HOME_01-pending .vehicle-menu-wrapper select {
        display: none !important;
      }
      html.SCS_HOME_01-pending .banner-container .vehicle-menu-container {
        opacity: 0;
        pointer-events: none;
        width: 100%;
        max-width: var(--scs-home-01-menu-max-w);
        min-height: var(--scs-home-01-menu-min-h);
        margin-left: 0;
        margin-right: auto;
        box-sizing: border-box;
      }
      html.SCS_HOME_01-pending .vehicle-menu-wrapper,
      html.SCS_HOME_01-ready .vehicle-menu-wrapper  {
        min-height: var(--scs-home-01-menu-min-h);
        width: 100%;
        max-width: var(--scs-home-01-menu-max-w);
        box-sizing: border-box;
      }
      html.SCS_HOME_01-pending .select-your-vehicle {
        visibility: hidden;
        min-height: var(--scs-home-01-heading-min-h);
      }
      @media (max-width: 767px) {
        html.SCS_HOME_01-pending {
          --scs-home-01-menu-min-h: 54px;
          --scs-home-01-heading-min-h: 48px;
          --scs-home-01-menu-max-w: 100%;
        }
        html.SCS_HOME_01-pending .select-your-vehicle {
          display: inline-block;
        }
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        html.SCS_HOME_01-pending {
          --scs-home-01-menu-max-w: 640px;
        }
      }
      @media (max-width: 480px) {
        html.SCS_HOME_01-pending {
          --scs-home-01-menu-min-h: 50px;
        }
      }
    `;
    (document.head || root).appendChild(style);
  }

  static markReady() {
    const root = document.documentElement;
    root.classList.remove('SCS_HOME_01-pending');
    root.classList.add('SCS_HOME_01-ready');
    document.getElementById(SCSHome01.CRITICAL_STYLE_ID)?.remove();
  }

  constructor() {
    this.tn = SCSHome01.TEST_NAME;
    this.selectedVehicle = null;
    this.query = '';
    this.results = [];
    this.isOpen = false;
    this.isLoading = false;
    this.activeIndex = -1;
    this.selectionLocked = false;
    this.requestId = 0;
    this.debounceTimer = null;
    this.refs = {};
  }

  static runAt(selector, callback) {
    const tryFind = () => {
      const el = document.querySelector(selector);
      if (el) {
        callback(el);
        return true;
      }
      return false;
    };

    if (tryFind()) return;

    const observer = new MutationObserver(() => {
      if (tryFind()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  static vehicleLabel(vehicle) {
    if (!vehicle) return '';
    return (
      vehicle.full_name ||
      [vehicle.year, vehicle.make, vehicle.model, vehicle.trim, vehicle.cab]
        .filter(Boolean)
        .join(' ')
    );
  }

  static escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  static highlightLabelHtml(label, query) {
    const safeLabel = SCSHome01.escapeHtml(label);
    const q = query.trim();
    if (!q) return `<span>${safeLabel}</span>`;

    const yearMatch = label.match(/^(\d{4})\s+(.*)$/);
    if (yearMatch) {
      return `<strong class="${SCSHome01.TEST_NAME}__year">${SCSHome01.escapeHtml(yearMatch[1])}</strong> <span>${SCSHome01.escapeHtml(yearMatch[2])}</span>`;
    }

    return `<span>${safeLabel}</span>`;
  }

  transformDom(wrapper) {
    if (wrapper.dataset.scsHome01Ready) return;
    wrapper.dataset.scsHome01Ready = 'true';

    const banner = wrapper.closest('.banner-container');
    const heading = banner?.querySelector('.select-your-vehicle');
    if (heading) heading.textContent = 'What do you drive?';

    ['#year-input-container', '#make-input-container', '#model-input-container'].forEach((sel) => {
      document.querySelectorAll(sel).forEach((node) => node.remove());
    });

    wrapper.querySelectorAll('.line').forEach((line) => {
      line.style.display = 'none';
    });

    const mobileWrap = wrapper.querySelector('.vehicle-input-mobile');
    if (mobileWrap) mobileWrap.style.display = 'none';

    const buttonWrap = wrapper.querySelector('.vehicle-button');
    const typeahead = document.createElement('div');
    typeahead.id = SCSHome01.TEST_NAME;
    typeahead.className = `${this.tn}__typeahead-wrap`;
    typeahead.innerHTML = `
      <label class="${this.tn}__label" for="${this.tn}_vehicle-search">Search year, make, model</label>
      <div class="${this.tn}__typeahead-field">
        <div class="${this.tn}__ghost" aria-hidden="true">
          <span class="${this.tn}__ghost-typed"></span>
          <span class="${this.tn}__ghost-rest"></span>
        </div>
        <input
          id="${this.tn}_vehicle-search"
          class="${this.tn}__input"
          type="text"
          autocomplete="off"
          spellcheck="false"
          placeholder="e.g. 2024 Ford F-150"
          aria-label="Search year, make, model"
          aria-autocomplete="list"
          aria-expanded="false"
          aria-controls="${this.tn}_listbox"
        />
      </div>
    `;

    if (buttonWrap) {
      wrapper.insertBefore(typeahead, buttonWrap);
    } else {
      wrapper.appendChild(typeahead);
    }

    const list = document.createElement('ul');
    list.id = `${this.tn}_listbox`;
    list.className = `${this.tn}__list`;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    typeahead.querySelector(`.${this.tn}__typeahead-field`).appendChild(list);

    const submitButton =
      wrapper.querySelector('#vehicle-submit-button') ||
      wrapper.querySelector('.vehicle-button button');

    this.refs = {
      wrapper,
      typeahead,
      input: typeahead.querySelector(`.${this.tn}__input`),
      ghostTyped: typeahead.querySelector(`.${this.tn}__ghost-typed`),
      ghostRest: typeahead.querySelector(`.${this.tn}__ghost-rest`),
      list,
      submitButton,
    };

    this.bindEvents();
    this.watchSubmitButton();
    this.setSubmitEnabled(false);
    SCSHome01.markReady();
  }

  watchSubmitButton() {
    const { submitButton } = this.refs;
    if (!submitButton || typeof MutationObserver === 'undefined') return;

    const observer = new MutationObserver(() => {
      if (this.selectedVehicle && submitButton.disabled) {
        this.setSubmitEnabled(true);
      }
    });

    observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  bindEvents() {
    const { input, submitButton } = this.refs;

    input.addEventListener('input', () => this.onInputChange());
    input.addEventListener('keydown', (e) => this.onKeyDown(e));
    input.addEventListener('focus', () => this.onFocus());
    input.addEventListener('blur', () => {
      window.setTimeout(() => this.closeDropdown(), 150);
    });

    if (submitButton) {
      submitButton.addEventListener('click', (e) => this.onSubmitClick(e), true);
    }
  }

  onInputChange() {
    const { input } = this.refs;
    this.selectionLocked = false;
    this.query = input.value;
    this.selectedVehicle = null;
    this.setSubmitEnabled(false);
    this.updateGhost();
    this.scheduleFetch();
  }

  onFocus() {
    if (this.selectionLocked) return;
    window.requestAnimationFrame(() => this.scrollInputToTop());
    if (this.results.length) this.openDropdown();
  }

  static getStickyOffset() {
    const candidates = document.querySelectorAll('.section-header, .header-wrapper, header.header');
    let offset = 0;
    candidates.forEach((el) => {
      const position = window.getComputedStyle(el).position;
      if (position === 'sticky' || position === 'fixed') {
        offset = Math.max(offset, el.getBoundingClientRect().height);
      }
    });
    return offset + 12;
  }

  scrollInputToTop() {
    if (window.innerWidth > 767) return;
    const { wrapper } = this.refs;
    if (!wrapper) return;

    const targetTop = Math.max(
      window.scrollY + wrapper.getBoundingClientRect().top - SCSHome01.getStickyOffset(),
      0
    );

    if (Math.abs(targetTop - window.scrollY) > 8) {
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }
  }

  scheduleFetch() {
    clearTimeout(this.debounceTimer);
    const q = this.query.trim();

    if (q.length < SCSHome01.MIN_QUERY_LENGTH) {
      this.results = [];
      this.closeDropdown();
      this.setLoading(false);
      return;
    }

    if (this.selectionLocked) {
      this.setLoading(false);
      return;
    }

    this.setLoading(true);
    const requestId = ++this.requestId;

    this.debounceTimer = window.setTimeout(async () => {
      try {
        const vehicles = await this.fetchTypeahead(q);
        if (requestId !== this.requestId || this.selectionLocked) {
          this.setLoading(false);
          return;
        }
        this.results = vehicles;
        this.activeIndex = vehicles.length ? 0 : -1;
        this.setLoading(false);
        this.openDropdown();
        this.renderDropdown();
        this.updateGhost();
      } catch (err) {
        if (requestId !== this.requestId || this.selectionLocked) {
          this.setLoading(false);
          return;
        }
        console.error('SCS_HOME_01 typeahead error', err);
        this.results = [];
        this.activeIndex = -1;
        this.setLoading(false);
        this.openDropdown();
        this.renderDropdown();
        this.updateGhost();
      }
    }, SCSHome01.DEBOUNCE_MS);
  }

  async fetchTypeahead(q) {
    const url = `${SCSHome01.TYPEAHEAD_API}?q=${encodeURIComponent(q)}`;
    const response = await fetch(url, { mode: 'cors' });
    if (!response.ok) {
      throw new Error(`Vehicle typeahead fetch failed: ${response.statusText}`);
    }
    const data = await response.json();
    return Array.isArray(data?.vehicles) ? data.vehicles : [];
  }

  getGhostSuffix() {
    if (!this.results.length || this.activeIndex < 0) return '';
    const label = SCSHome01.vehicleLabel(this.results[this.activeIndex]);
    if (!label.toLowerCase().startsWith(this.query.toLowerCase())) return '';
    return label.slice(this.query.length);
  }

  updateGhost() {
    const { ghostTyped, ghostRest } = this.refs;
    if (!ghostTyped || !ghostRest) return;
    ghostTyped.textContent = this.query;
    ghostRest.textContent = this.getGhostSuffix();
  }

  setLoading(loading) {
    this.isLoading = loading;
    const { input } = this.refs;
    if (input) input.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  openDropdown() {
    if (this.isOpen) return;
    this.isOpen = true;
    const { input, list } = this.refs;
    if (input) input.setAttribute('aria-expanded', 'true');
    if (list) list.hidden = false;
  }

  closeDropdown() {
    if (!this.isOpen) return;
    this.isOpen = false;
    const { input, list } = this.refs;
    if (input) input.setAttribute('aria-expanded', 'false');
    if (list) list.hidden = true;
  }

  renderDropdown() {
    const { list } = this.refs;
    if (!list) return;

    if (!this.results.length) {
      list.innerHTML = `<li class="${this.tn}__empty">No vehicles found</li>`;
      return;
    }

    list.innerHTML = this.results
      .map((vehicle, index) => {
        const label = SCSHome01.vehicleLabel(vehicle);
        const activeClass = index === this.activeIndex ? ' is-active' : '';
        return `
          <li>
            <button
              type="button"
              role="option"
              class="${this.tn}__option${activeClass}"
              aria-selected="${index === this.activeIndex}"
              data-index="${index}"
            >
              ${SCSHome01.highlightLabelHtml(label, this.query)}
            </button>
          </li>
        `;
      })
      .join('');

    list.querySelectorAll(`.${this.tn}__option`).forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        this.activeIndex = Number(btn.dataset.index);
        this.updateActiveOption();
        this.updateGhost();
      });
      btn.addEventListener('mousedown', (e) => e.preventDefault());
      btn.addEventListener('click', () => {
        const vehicle = this.results[Number(btn.dataset.index)];
        if (vehicle) this.pickVehicle(vehicle);
      });
    });
  }

  updateActiveOption() {
    const { list } = this.refs;
    if (!list) return;

    list.querySelectorAll(`.${this.tn}__option`).forEach((btn, index) => {
      const isActive = index === this.activeIndex;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', String(isActive));
    });
  }

  pickVehicle(vehicle) {
    this.requestId += 1;
    this.selectionLocked = true;
    this.selectedVehicle = vehicle;
    this.query = SCSHome01.vehicleLabel(vehicle);
    this.refs.input.value = this.query;
    this.results = [];
    this.activeIndex = -1;
    this.setLoading(false);
    this.closeDropdown();
    this.updateGhost();
    this.setSubmitEnabled(true);
    this.refs.input.blur();
  }

  onKeyDown(e) {
    const ghostSuffix = this.getGhostSuffix();

    if (!this.isOpen || !this.results.length) {
      if (e.key === 'Tab' && ghostSuffix && this.results[0]) {
        e.preventDefault();
        this.pickVehicle(this.results[this.activeIndex >= 0 ? this.activeIndex : 0]);
      }
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.activeIndex = Math.min(this.activeIndex + 1, this.results.length - 1);
      this.updateActiveOption();
      this.updateGhost();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      this.updateActiveOption();
      this.updateGhost();
    } else if (e.key === 'Enter' && this.activeIndex >= 0) {
      e.preventDefault();
      this.pickVehicle(this.results[this.activeIndex]);
    } else if (e.key === 'Tab' && ghostSuffix && this.activeIndex >= 0) {
      e.preventDefault();
      this.pickVehicle(this.results[this.activeIndex]);
    } else if (e.key === 'Escape') {
      this.closeDropdown();
    }
  }

  setSubmitEnabled(enabled) {
    const { submitButton } = this.refs;
    if (!submitButton) return;
    if (enabled) {
      submitButton.disabled = false;
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.disabled = true;
      submitButton.setAttribute('disabled', '');
    }
  }

  onSubmitClick(e) {
    if (!this.selectedVehicle) return;
    e.preventDefault();
    e.stopPropagation();

    const { make, model, year, trim, cab } = this.selectedVehicle;
    if (!make || !model || !year) return;

    try {
      window.sessionStorage.setItem('user_make', make);
      window.sessionStorage.setItem('user_model', model);
      window.sessionStorage.setItem('user_year', String(year));
      if (trim) window.sessionStorage.setItem('user_trim', trim);
      if (cab) window.sessionStorage.setItem('user_cab', cab);
    } catch (_) {
      /* ignore storage errors */
    }

    const params = new URLSearchParams({
      make,
      model,
      year: String(year),
    });
    if (trim) params.set('trim', trim);
    if (cab) params.set('cab', cab);

    const url = `${SCSHome01.REDIRECT_BASE}?${params.toString()}`;
    if (typeof window.__SCS_HOME_01_CAPTURE_REDIRECT__ === 'function') {
      window.__SCS_HOME_01_CAPTURE_REDIRECT__(url);
      return;
    }
    window.location.assign(url);
  }

  init() {
    if (window.__SCS_HOME_01_INITIALIZED__) return;
    window.__SCS_HOME_01_INITIALIZED__ = true;

    SCSHome01.installCriticalHide();

    const applyBodyClass = () => {
      document.body?.classList.add(this.tn);
    };
    if (document.body) applyBodyClass();
    else document.addEventListener('DOMContentLoaded', applyBodyClass, { once: true });

    SCSHome01.runAt(SCSHome01.WRAPPER_SELECTOR, (wrapper) => {
      this.transformDom(wrapper);
    });
  }
}

if (window.scs_scs_home_01 == true) {
  SCSHome01.installCriticalHide();
  new SCSHome01().init();
}